import { withProps } from 'recompose';
import { partial } from 'lodash';

export const withBindRouterIdToActions = actionsNames =>
  withProps(props => actionsNames.reduce((memo, action) => ({
    ...memo,
    [action]: partial(props[action], props.params.id),
  }), {}));

export default withBindRouterIdToActions;
